import { Add, Close } from '@mui/icons-material';
import { Button, Divider, FormControl, FormHelperText, Grid, InputLabel, Menu, MenuItem, OutlinedInput, Select, Switch, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStateRef } from 'app/services';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { Controller, FormProvider, useFieldArray, useForm, useFormContext, } from 'react-hook-form';
const setNestedValue = (setValue, path, value) => {
    setValue(path, value);
};
const RenderFieldArray = ({ field, error, register, registerKey, control, firstUpdate, disableRemove, setValue, onRemove, }) => (React.createElement(React.Fragment, { key: field.id },
    React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.title), margin: 'normal', fullWidth: true },
                React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A"),
                React.createElement(Controller, { name: `${registerKey}.title`, defaultValue: '', control: control, rules: { required: true }, render: ({ field: controllerField }) => (React.createElement(OutlinedInput, { label: '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A', value: controllerField.value, placeholder: '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A', notched: firstUpdate, onChange: controllerField.onChange, onBlur: controllerField.onBlur, name: controllerField.name, inputRef: controllerField.ref })) }))),
        React.createElement(Grid, { item: true, xs: 4.5 },
            React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.type), variant: 'outlined', margin: 'normal', fullWidth: true },
                React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0422\u0438\u043F"),
                React.createElement(Select, Object.assign({ label: '\u0422\u0438\u043F', defaultValue: '', notched: firstUpdate, value: field.type, MenuProps: {
                        sx: {
                            '.MuiPaper-root:before': {
                                display: 'none',
                            },
                        },
                    } }, register(`${registerKey}.type`, {
                    required: true,
                    onChange: (e) => {
                        const selectedValue = e.target.value;
                        const selectedItem = config.transportGroupCheckListFormMenu.find((item) => item.value === selectedValue);
                        if (selectedItem.originalValue !== 'select') {
                            setNestedValue(setValue, `${registerKey}.values`, '');
                        }
                        if (selectedItem.originalValue !== 'boolean') {
                            setNestedValue(setValue, `${registerKey}.required`, 0);
                        }
                        field.type = selectedValue;
                        setNestedValue(setValue, `${registerKey}.type`, selectedValue);
                    },
                })), config.transportGroupCheckListFormMenu.map((item, key) => (React.createElement(MenuItem, { key: key, value: item.value, disableRipple: true }, item.title)))))),
        React.createElement(Grid, { item: true, xs: 1.5 },
            React.createElement(Button, { variant: 'contained', size: 'large', disableElevation: true, disabled: disableRemove, onClick: disableRemove ? undefined : onRemove, endIcon: React.createElement(Close, null), sx: (theme) => ({
                    position: 'relative',
                    minWidth: 'auto',
                    borderRadius: theme.spacing(1),
                    color: theme.palette.text.secondary,
                    padding: '12px 12px',
                    bgcolor: 'background.default',
                    marginTop: '15px',
                    marginBottom: theme.spacing(1),
                    marginLeft: '3px',
                    span: {
                        margin: theme.spacing(0),
                    },
                    path: {
                        fill: theme.palette.text.secondary,
                    },
                    '&:hover, &.active': {
                        bgcolor: 'background.default',
                    },
                    '&.Mui-disabled': {
                        bgcolor: 'background.default',
                        opacity: 0.75,
                    },
                }) }))),
    (field === null || field === void 0 ? void 0 : field.type) === 'select' && (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.values), margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                    width: '100%',
                    marginTop: theme.spacing(2),
                }) },
                React.createElement(InputLabel, null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430"),
                React.createElement(OutlinedInput, Object.assign({ label: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430', placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430' }, register(`${registerKey}.values`, {
                    onChange: (e) => setNestedValue(setValue, `${registerKey}.values`, e.target.value.replace(
                    // eslint-disable-next-line no-useless-escape
                    /[!@#$%^&*()_+\-=\[\]{}':"\\|,.<>\/?]+/, '')),
                }))),
                React.createElement(FormHelperText, null, "\u0415\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u0443\u043D\u043A\u0442\u043E\u0432, \u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0443\u043D\u043A\u0442 1;\u043F\u0443\u043D\u043A\u0442 2"))))),
    (field === null || field === void 0 ? void 0 : field.type) === 'boolean' && (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.required), margin: 'normal', variant: 'outlined', fullWidth: true, sx: (theme) => ({
                        width: '100%',
                        marginTop: theme.spacing(2),
                    }) },
                    React.createElement(InputLabel, null, "\u0412\u043B\u0438\u044F\u0435\u0442 \u043D\u0430 \u0432\u044B\u0435\u0437\u0434"),
                    React.createElement(Select, Object.assign({ label: '\u0412\u043B\u0438\u044F\u0435\u0442 \u043D\u0430 \u0432\u044B\u0435\u0437\u0434', notched: firstUpdate, value: field.required, MenuProps: {
                            sx: {
                                '.MuiPaper-root:before': {
                                    display: 'none',
                                },
                            },
                        } }, register(`${registerKey}.required`, {
                        onChange: (e) => {
                            field.required = e.target.value;
                            setNestedValue(setValue, `${registerKey}.required`, e.target.value);
                        },
                    })),
                        React.createElement(MenuItem, { value: 0, disableRipple: true }, "\u041D\u0435\u0442"),
                        React.createElement(MenuItem, { value: 1, disableRipple: true }, "\u0414\u0430")),
                    React.createElement(FormHelperText, null, "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u0434\u043E\u043F\u0443\u0441\u043A \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u043A \u0432\u044B\u0435\u0437\u0434\u0443")))),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.required), margin: 'normal', variant: 'outlined', sx: (theme) => ({
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px',
                        borderRadius: '4px',
                    }) },
                    React.createElement(Typography, { variant: 'body2' }, "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439"),
                    React.createElement(Switch, Object.assign({ edge: 'end', size: 'small' }, register(`${registerKey}.is_comment`), { onChange: (e) => {
                            const currentValue = e.target.checked;
                            field.is_comment = currentValue;
                            setNestedValue(setValue, `${registerKey}.is_comment`, currentValue);
                        }, checked: Boolean(field.is_comment) }))),
                React.createElement(FormHelperText, null, "\u041E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u043F\u0440\u0438 \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u043C \u0432\u044B\u0431\u043E\u0440\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441\u0430")),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!(error === null || error === void 0 ? void 0 : error.required), margin: 'normal', variant: 'outlined', sx: (theme) => ({
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px',
                        borderRadius: '4px',
                    }) },
                    React.createElement(Typography, { variant: 'body2' }, "\u0424\u043E\u0442\u043E"),
                    React.createElement(Switch, Object.assign({ edge: 'end', size: 'small' }, register(`${registerKey}.is_photo`), { onChange: (e) => {
                            const currentValue = e.target.checked;
                            field.is_photo = currentValue;
                            setNestedValue(setValue, `${registerKey}.is_photo`, currentValue);
                        }, checked: Boolean(field.is_photo) }))),
                React.createElement(FormHelperText, null, "\u0414\u043E\u0431\u0430\u0432\u043B\u044F\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043F\u0440\u0438 \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u043C \u0432\u044B\u0431\u043E\u0440\u0435 \u0447\u0435\u043A\u0431\u043E\u043A\u0441\u0430")))))));
const ChecklistTemplateFieldArray = ({ index: parentIndex, onRemove: parentOnRemove, firstUpdate, disableRemove }) => {
    var _a, _b;
    const { register, control, setValue, formState } = useFormContext();
    const { fields, remove, append } = useFieldArray({
        control,
        name: `checkpoints.${parentIndex}.checkpoints`,
    });
    const onRemove = (index) => (fields.length > 1 ? remove(index) : parentOnRemove(parentIndex));
    const onAppend = () => append({
        type: '',
        title: '',
        values: '',
        required: 0,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 10.5 },
                React.createElement(FormControl, { error: !!((_b = (_a = formState.errors.checkpoints) === null || _a === void 0 ? void 0 : _a[parentIndex]) === null || _b === void 0 ? void 0 : _b.title), margin: 'normal', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B \u0447\u0435\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432"),
                    React.createElement(Controller, { name: `checkpoints.${parentIndex}.title`, defaultValue: '', control: control, rules: { required: true }, render: ({ field }) => (React.createElement(OutlinedInput, { label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B \u0447\u0435\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432', value: field.value, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B \u0447\u0435\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432', notched: firstUpdate, onChange: field.onChange, onBlur: field.onBlur, name: field.name, inputRef: field.ref })) }))),
            React.createElement(Grid, { item: true, xs: 1.5 },
                React.createElement(Button, { variant: 'contained', size: 'large', disableElevation: true, onClick: onAppend, endIcon: React.createElement(Add, null), sx: (theme) => ({
                        position: 'relative',
                        minWidth: 'auto',
                        borderRadius: theme.spacing(1),
                        color: theme.palette.text.secondary,
                        padding: '12px 12px',
                        bgcolor: 'background.default',
                        marginTop: '15px',
                        marginBottom: theme.spacing(1),
                        marginLeft: '3px',
                        span: {
                            margin: theme.spacing(0),
                        },
                        path: {
                            fill: theme.palette.text.secondary,
                        },
                        '&:hover, &.active': {
                            bgcolor: 'background.default',
                        },
                    }) }))),
        fields.map((field, index) => {
            var _a, _b, _c;
            return (React.createElement(React.Fragment, { key: field.id },
                React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                        width: '100%',
                        alignSelf: 'center',
                        justifyContent: 'center',
                        marginTop: theme.spacing(1.25),
                        marginBottom: theme.spacing(1.25),
                    }) },
                    React.createElement(Typography, { variant: 'body2' },
                        "\u0427\u0435\u043A\u043F\u043E\u0438\u043D\u0442 ",
                        parentIndex + 1,
                        ".",
                        index + 1)),
                React.createElement(RenderFieldArray, { field: field, registerKey: `checkpoints.${parentIndex}.checkpoints.${index}`, firstUpdate: firstUpdate, register: register, control: control, setValue: setValue, onRemove: () => onRemove(index), disableRemove: fields.length < 2 ? disableRemove : false, error: (_c = (_b = (_a = formState.errors.checkpoints) === null || _a === void 0 ? void 0 : _a[parentIndex]) === null || _b === void 0 ? void 0 : _b.checkpoints) === null || _c === void 0 ? void 0 : _c[index] })));
        })));
};
const mapApiCheckpointToForm = (checkpoint) => {
    if (checkpoint.length === 2) {
        const groupTuple = checkpoint;
        const title = groupTuple[0];
        const nestedCheckpoints = groupTuple[1];
        return {
            title,
            checkpoints: nestedCheckpoints.map((nested) => {
                const [type, subTitle, values, required, is_comment, is_photo] = nested;
                return {
                    type,
                    title: subTitle,
                    values: values,
                    required,
                    is_comment,
                    is_photo,
                };
            }),
        };
    }
    const [type, title, values, required, is_comment, is_photo] = checkpoint;
    return {
        type,
        title,
        values: values,
        required,
        is_comment,
        is_photo,
    };
};
const ChecklistTemplateForm = forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    const { defaultValues, onSubmit } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
    const form = useForm({
        defaultValues: {
            name: defaultValues ? (_a = defaultValues.name) !== null && _a !== void 0 ? _a : '' : '',
            active: defaultValues ? (_b = defaultValues.active) !== null && _b !== void 0 ? _b : 1 : 1,
            group_id: defaultValues ? (_c = defaultValues.group_id) !== null && _c !== void 0 ? _c : null : null,
            inspection_mode: (_d = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.inspection_mode) !== null && _d !== void 0 ? _d : '',
            summary_position: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.summary_position) === 'start' ? 'start' : 'end',
            checkpoints: defaultValues
                ? defaultValues.checkpoints
                : [
                    {
                        type: '',
                        title: '',
                        values: '',
                        required: 0,
                        is_comment: false,
                        is_photo: false,
                    },
                ],
        },
    });
    const { watch, control, setValue, register, handleSubmit, formState, reset } = form;
    const inspectionModeWatch = watch('inspection_mode');
    const isDefectsFirstMode = inspectionModeWatch === 'defects_first';
    const { fields, append, remove } = useFieldArray({
        name: 'checkpoints',
        control,
    });
    const watchFieldArray = watch('checkpoints');
    const handleAppendCheckpoint = () => {
        setAnchorEl(null);
        append({
            type: '',
            title: '',
            values: '',
            required: 0,
            is_comment: false,
            is_photo: false,
        });
    };
    const handleAppendCheckpoints = () => {
        setAnchorEl(null);
        append({
            title: '',
            checkpoints: [
                {
                    type: '',
                    title: '',
                    values: '',
                    required: 0,
                    is_comment: false,
                    is_photo: false,
                },
            ],
        });
    };
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => {
                const inspectionMode = data.inspection_mode === '' ? null : data.inspection_mode;
                onSubmit({
                    id: defaultValues && 'id' in defaultValues ? defaultValues.id : undefined,
                    name: data.name,
                    active: data.active,
                    group_id: data.group_id ? data.group_id : undefined,
                    inspection_mode: inspectionMode,
                    summary_position: inspectionMode === 'defects_first' && data.summary_position === 'start' ? 'start' : null,
                    checkpoints: data.checkpoints.map((checkpoint) => (Object.assign(Object.assign({}, checkpoint), { is_comment: checkpoint.is_comment ? 1 : 0, is_photo: checkpoint.is_photo ? 1 : 0, checkpoints: checkpoint.checkpoints
                            ? checkpoint.checkpoints.map((subCheckpoint) => (Object.assign(Object.assign({}, subCheckpoint), { is_comment: subCheckpoint.is_comment ? 1 : 0, is_photo: subCheckpoint.is_photo ? 1 : 0 })))
                            : undefined }))),
                });
            })();
        },
    }));
    useLayoutEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        var _a, _b, _c;
        if (defaultValues) {
            reset({
                name: (_a = defaultValues.name) !== null && _a !== void 0 ? _a : '',
                active: (_b = defaultValues.active) !== null && _b !== void 0 ? _b : 1,
                group_id: defaultValues.group_id ? defaultValues.group_id : null,
                inspection_mode: (_c = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.inspection_mode) !== null && _c !== void 0 ? _c : '',
                summary_position: (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.summary_position) === 'start' ? 'start' : 'end',
                checkpoints: defaultValues.checkpoints.map(mapApiCheckpointToForm),
            });
        }
    }, [defaultValues]);
    return (React.createElement(FormProvider, Object.assign({}, form),
        React.createElement("form", null,
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormControl, { error: !!formState.errors.name, variant: 'outlined', margin: 'normal', fullWidth: true },
                            React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                            React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435', notched: firstUpdate, fullWidth: true, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435' }, register('name', {
                                required: true,
                                minLength: 3,
                            }))),
                            React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0447\u0435\u043A\u043B\u0438\u0441\u0442\u0430 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0430\u0445"))),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormControl, { error: !!formState.errors.active, variant: 'outlined', margin: 'normal', fullWidth: true },
                            React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                            React.createElement(Controller, { name: 'active', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0421\u0442\u0430\u0442\u0443\u0441', notched: firstUpdate, value: field.value, MenuProps: {
                                        sx: {
                                            '.MuiPaper-root:before': {
                                                display: 'none',
                                            },
                                        },
                                    } }, register(field.name, {
                                    required: true,
                                })),
                                    React.createElement(MenuItem, { value: 0 }, "\u041D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D"),
                                    React.createElement(MenuItem, { value: 1 }, "\u0410\u043A\u0442\u0438\u0432\u0435\u043D"))) }),
                            React.createElement(FormHelperText, null, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u0447\u0435\u043A\u043B\u0438\u0441\u0442\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043E\u0441\u043C\u043E\u0442\u0440\u0430"))),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormControl, { variant: 'outlined', margin: 'normal', fullWidth: true },
                            React.createElement(InputLabel, { shrink: true, disableAnimation: firstUpdate }, "\u0420\u0435\u0436\u0438\u043C \u043E\u0441\u043C\u043E\u0442\u0440\u0430 (\u043C\u043E\u0431.)"),
                            React.createElement(Controller, { name: 'inspection_mode', control: control, render: ({ field }) => {
                                    var _a;
                                    return (React.createElement(Select, { label: '\u0420\u0435\u0436\u0438\u043C \u043E\u0441\u043C\u043E\u0442\u0440\u0430 (\u043C\u043E\u0431.)', notched: true, displayEmpty: true, value: (_a = field.value) !== null && _a !== void 0 ? _a : '', onChange: (e) => {
                                            const next = e.target.value;
                                            field.onChange(next);
                                            if (next !== 'defects_first') {
                                                setValue('summary_position', 'end');
                                            }
                                        }, renderValue: (selected) => {
                                            if (!selected) {
                                                return 'По умолчанию (подробный)';
                                            }
                                            if (selected === 'defects_first') {
                                                return 'Акцент на важном (быстрый)';
                                            }
                                            return String(selected);
                                        }, MenuProps: {
                                            sx: {
                                                '.MuiPaper-root:before': {
                                                    display: 'none',
                                                },
                                            },
                                        } },
                                        React.createElement(MenuItem, { value: '' }, "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E (\u043F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0439)"),
                                        React.createElement(MenuItem, { value: 'defects_first' }, "\u0410\u043A\u0446\u0435\u043D\u0442 \u043D\u0430 \u0432\u0430\u0436\u043D\u043E\u043C (\u0431\u044B\u0441\u0442\u0440\u044B\u0439)")));
                                } }),
                            React.createElement(FormHelperText, null, "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u2014 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0439 \u0441\u0446\u0435\u043D\u0430\u0440\u0438\u0439; \u00AB\u0410\u043A\u0446\u0435\u043D\u0442 \u043D\u0430 \u0432\u0430\u0436\u043D\u043E\u043C\u00BB \u2014 \u0431\u044B\u0441\u0442\u0440\u044B\u0439 \u0440\u0435\u0436\u0438\u043C \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F."))),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(FormControl, { variant: 'outlined', margin: 'normal', fullWidth: true, disabled: !isDefectsFirstMode },
                            React.createElement(InputLabel, { shrink: true, disableAnimation: firstUpdate }, "\u0411\u043B\u043E\u043A \u0441\u0430\u043C\u043C\u0430\u0440\u0438"),
                            React.createElement(Controller, { name: 'summary_position', control: control, render: ({ field }) => {
                                    var _a;
                                    return (React.createElement(Select, { label: '\u0411\u043B\u043E\u043A \u0441\u0430\u043C\u043C\u0430\u0440\u0438', notched: true, displayEmpty: true, value: (_a = field.value) !== null && _a !== void 0 ? _a : 'end', onChange: (e) => field.onChange(e.target.value), renderValue: (selected) => (selected === 'start' ? 'В начале шаблона' : 'В конце шаблона'), MenuProps: {
                                            sx: {
                                                '.MuiPaper-root:before': {
                                                    display: 'none',
                                                },
                                            },
                                        } },
                                        React.createElement(MenuItem, { value: 'end' }, "\u0412 \u043A\u043E\u043D\u0446\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0430"),
                                        React.createElement(MenuItem, { value: 'start' }, "\u0412 \u043D\u0430\u0447\u0430\u043B\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0430")));
                                } }),
                            React.createElement(FormHelperText, null, isDefectsFirstMode
                                ? 'Где показывать блок саммари в быстром режиме на мобилке.'
                                : 'Доступно только для режима «Акцент на важном (быстрый)».')))),
                fields.length !== 0 &&
                    fields.map((field, index) => {
                        var _a;
                        if (Object.prototype.hasOwnProperty.call(field, 'checkpoints')) {
                            return (React.createElement(React.Fragment, { key: field.id },
                                React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                                        width: '100%',
                                        alignSelf: 'center',
                                        justifyContent: 'center',
                                        marginTop: theme.spacing(1.25),
                                        marginBottom: theme.spacing(1.25),
                                    }) },
                                    React.createElement(Typography, { variant: 'body2' },
                                        "\u0427\u0435\u043A\u043F\u043E\u0438\u043D\u0442 ",
                                        index + 1)),
                                React.createElement(ChecklistTemplateFieldArray, { index: index, firstUpdate: firstUpdate, disableRemove: fields.length < 2, onRemove: () => remove(index) })));
                        }
                        return (React.createElement(React.Fragment, { key: field.id },
                            React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                                    width: '100%',
                                    alignSelf: 'center',
                                    justifyContent: 'center',
                                    marginTop: theme.spacing(1.25),
                                    marginBottom: theme.spacing(1.25),
                                }) },
                                React.createElement(Typography, { variant: 'body2' },
                                    "\u0427\u0435\u043A\u043F\u043E\u0438\u043D\u0442 ",
                                    index + 1)),
                            React.createElement(RenderFieldArray, { field: field, registerKey: `checkpoints.${index}`, firstUpdate: firstUpdate, register: register, control: control, setValue: setValue, disableRemove: fields.length < 2, error: (_a = formState.errors.checkpoints) === null || _a === void 0 ? void 0 : _a[index], onRemove: () => remove(index) })));
                    }),
                React.createElement(Divider, { textAlign: 'center', sx: (theme) => ({
                        width: '100%',
                        alignSelf: 'center',
                        justifyContent: 'center',
                        marginTop: theme.spacing(2.25),
                        marginBottom: theme.spacing(1.25),
                    }) },
                    React.createElement(Button, { id: 'checkpointAdd', variant: 'outlined', size: 'medium', onClick: (e) => setAnchorEl(e.currentTarget), sx: (theme) => ({
                            gap: '4px',
                            padding: '3px 10px',
                            borderRadius: '50px',
                            fontSize: '10px',
                            minWidth: '40px',
                            color: theme.palette.text.secondary,
                            bgcolor: 'background.default',
                            borderColor: 'background.default',
                            '&:hover, &.active': {
                                bgcolor: 'background.default',
                                borderColor: 'background.default',
                            },
                            svg: {
                                fontSize: '18px',
                            },
                        }) },
                        React.createElement(Add, null)),
                    React.createElement(Menu, { id: 'checkpointAdd', open: !!anchorEl, onClose: () => setAnchorEl(null), anchorEl: anchorEl, anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        }, PaperProps: {
                            sx: {
                                '&:before': {
                                    display: 'none',
                                },
                            },
                        } },
                        React.createElement(MenuItem, { onClick: handleAppendCheckpoint }, "\u0427\u0435\u043A\u043F\u043E\u0438\u043D\u0442"),
                        React.createElement(MenuItem, { onClick: handleAppendCheckpoints }, "\u0413\u0440\u0443\u043F\u043F\u0443 \u0447\u0435\u043A\u043F\u043E\u0438\u043D\u0442\u043E\u0432")))))));
});
ChecklistTemplateForm.displayName = 'ChecklistTemplateForm';
export default ChecklistTemplateForm;
